var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterSolid = function SvgTwitterSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter-solid_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.025 4.175a8.227 8.227 0 0 1-2.364.648 4.123 4.123 0 0 0 1.81-2.275 8.258 8.258 0 0 1-2.613.997A4.113 4.113 0 0 0 9.85 7.297a11.68 11.68 0 0 1-8.478-4.299 4.097 4.097 0 0 0-.556 2.07c0 1.426.725 2.685 1.83 3.424A4.11 4.11 0 0 1 .78 7.977v.051a4.119 4.119 0 0 0 3.299 4.034 4.114 4.114 0 0 1-1.858.07 4.123 4.123 0 0 0 3.842 2.857 8.245 8.245 0 0 1-6.087 1.702 11.62 11.62 0 0 0 6.304 1.848c7.566 0 11.703-6.267 11.703-11.701 0-.179-.004-.358-.01-.533a8.361 8.361 0 0 0 2.051-2.13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter-solid_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgTwitterSolid;